import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCanadaFlagIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 17,
	viewBox: "0 0 24 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_26537_594433)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0.5 2.5C0.5 1.39543 1.39543 0.5 2.5 0.5H21.5C22.6046 0.5 23.5 1.39543 23.5 2.5V14.5C23.5 15.6046 22.6046 16.5 21.5 16.5H2.5C1.39543 16.5 0.5 15.6046 0.5 14.5V2.5Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.89422 0.5H18.1022V16.5H5.89062L5.89422 0.5Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M-0.207031 0.5H5.89516V16.5H-0.207031V0.5ZM18.1031 0.5H24.2053V16.5H18.1067L18.1031 0.5ZM7.72437 8.23333L7.24641 8.38L9.45297 10.18C9.62188 10.6367 9.39547 10.7733 9.25172 11.0133L11.6452 10.7333L11.5877 12.9667L12.0872 12.9567L11.9758 10.7367L14.3728 11.0033C14.2255 10.7133 14.0925 10.56 14.2291 10.0967L16.432 8.39667L16.0475 8.26333C15.7313 8.03667 16.1841 7.17667 16.2488 6.63333C16.2488 6.63333 14.9658 7.04333 14.8831 6.82667L14.5525 6.24333L13.3809 7.43667C13.2552 7.46667 13.2013 7.42 13.1689 7.32L13.708 4.82667L12.8527 5.27333C12.776 5.30222 12.7137 5.27778 12.6658 5.2L11.8392 3.66667L10.9911 5.26C10.924 5.31556 10.8641 5.32333 10.8114 5.28333L9.98844 4.86L10.4808 7.33C10.4413 7.43 10.3478 7.45667 10.24 7.40333L9.11875 6.22667C8.975 6.44333 8.87438 6.79667 8.68031 6.87667C8.48625 6.95667 7.83578 6.72667 7.40094 6.64333C7.55187 7.13667 8.01188 7.96333 7.72437 8.23333Z",
					fill: "#D52B1E"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.5 1H21.5C22.3284 1 23 1.67157 23 2.5V14.5C23 15.3284 22.3284 16 21.5 16H2.5C1.67157 16 1 15.3284 1 14.5V2.5C1 1.67157 1.67157 1 2.5 1Z",
			stroke: "#1C1D22",
			strokeOpacity: .08
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_26537_594433",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0.5 2.5C0.5 1.39543 1.39543 0.5 2.5 0.5H21.5C22.6046 0.5 23.5 1.39543 23.5 2.5V14.5C23.5 15.6046 22.6046 16.5 21.5 16.5H2.5C1.39543 16.5 0.5 15.6046 0.5 14.5V2.5Z",
				fill: "white"
			})
		}) })
	]
});
export default SvgCanadaFlagIcon;
